// extracted by mini-css-extract-plugin
export var root = "PlasmicHeadline-module--root--+FOhO";
export var headlineButton__xiaYn = "PlasmicHeadline-module--headlineButton__xiaYn--7zs16";
export var h1 = "PlasmicHeadline-module--h1--H4unP";
export var h1global_mode_dark = "PlasmicHeadline-module--h1global_mode_dark--9wTPQ";
export var textglobal_mode_dark = "PlasmicHeadline-module--textglobal_mode_dark--Dj8Cy";
export var headlineButton__b86Ep = "PlasmicHeadline-module--headlineButton__b86Ep--GtGdy";